var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStressLevel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1",
    "data-name": 1,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1ea614;}.cls-2{fill:#15660e;}.cls-3{fill:none;stroke:#15660e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:30px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.11,584.78A285,285,0,0,1,98.59,98.25a285,285,0,0,1,403,403.05A283.14,283.14,0,0,1,300.11,584.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.11,29.78A270.08,270.08,0,0,1,405.2,548.57,270.08,270.08,0,0,1,195,51a268.33,268.33,0,0,1,105.09-21.2m0-30c-165.68,0-300,134.31-300,300s134.32,300,300,300,300-134.32,300-300-134.31-300-300-300Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.22,355H480c-17.39,69.73-88.65,120.58-170.91,123.22C221.92,481,142.82,429,124.22,355Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M344,265c1.69-3.42,19.42-38,51-38,2.9,0,32.6.76,51,38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157,263c1.69-3.42,19.42-38,51-38,2.9,0,32.6.76,51,38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressLevel1);
export default __webpack_public_path__ + "static/media/stress_level_1.97fb39d478fd29f77e25a18be52f2786.svg";
export { ForwardRef as ReactComponent };